import React, {useRef, useState} from 'react'
import {Row, Col, Carousel as AntCarousel} from 'antd'
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack'
import QueueAnim from 'rc-queue-anim'
import TweenOne from 'rc-tween-one'
import Children from 'rc-tween-one/lib/plugin/ChildrenPlugin';
import TcXyj03 from '@/assets/images/tc_xyj03.png'
import TcLys04 from '@/assets/images/tc_lys04.png'
import TcTm05 from '@/assets/images/tc_tm05.png'
import TcTm06 from '@/assets/images/伏磊.png'
import TcTm07 from '@/assets/images/刘志伟.png'
import TcTm10 from '@/assets/images/夏凯.png'
import TcTm11 from '@/assets/images/宫玉振.png'
import TcTm12 from '@/assets/images/张春晓.png'
import TcTm13 from '@/assets/images/张黎.png'
import TcTm14 from '@/assets/images/施炜.png'
import TcTm15 from '@/assets/images/李常仓.png'
import TcTm16 from '@/assets/images/李翔宇.png'
import TcTm17 from '@/assets/images/狮明亮.png'
import TcTm18 from '@/assets/images/蒋丽华.png'
import TcTm19 from '@/assets/images/许玉林.png'
import TcTm20 from '@/assets/images/赵越.png'
import TcTm21 from '@/assets/images/逄增钢.png'
import TcTm22 from '@/assets/images/闫静.png'
import TcTm24 from '@/assets/images/高雄勇.png'
import TcTm25 from '@/assets/images/欧阳红武.png'
import TcTm26 from '@/assets/images/LisaZhang.png'

import ModelVideo from "@/components/ModelVideo";
const chunkSize = 3;

TweenOne.plugins.push(Children);

const Lecturer: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [current, setCurrent] = useState(0)
  const [obj, setObj] = useState(null)
  const [data, setData] = useState([
    // {
    //   name: '李越',
    //   desc: '复盘百企上市案例，提炼出一套系统实用的公司治理思维框架。曾任东方花旗投行董事及新三板融资并购监管经理。',
    //   cosKey: 'https://lecturermap-1319224539.cos.ap-beijing.myqcloud.com/cdn/%E5%AE%98%E7%BD%91/%E6%9D%8E%E8%B6%8A.mp4',
    //   img: TcLy01
    // },
    // {
    //   name: '程广见',
    //   desc: '销售全流程与信用回款研究第一人。《成交心法》作者，得到《跟程广见学做大客户销售》课程主理人，抖音粉丝超500W。',
    //   cosKey: 'https://lecturermap-1319224539.cos.ap-beijing.myqcloud.com/cdn/%E5%AE%98%E7%BD%91/%E7%A8%8B%E5%B9%BF%E8%A7%81.mp4',
    //   img: TcCgj02
    // },
    {
      name: '宫玉振',
      desc: '北京大学国家发展研究院教授，学术委员会副主任，著名军事与管理学家；腾讯、京东、百度、阿里等著名企业的高管导师。',
      cosKey: '',
      img: TcTm11
    },
    {
      name: '张黎',
      desc: '北大国家发展研究院管理学教授，中国商业联合会专家委员会委员、中国高校市场学学会理事，中国品牌研究中心顾问。',
      cosKey: '',
      img: TcTm13
    },
    {
      name: '汤敏',
      desc: '原国务院参事，中国经济50人成员。兼任北京大学中国经济研究中心教授，国务院扶贫办友成企业家扶贫基金会常务副理事长。',
      cosKey: '',
      img: TcTm05
    },
    {
      name: '许玉林',
      desc: '中国人民大学劳动人事学院教授，博士生导师，人力资源开发与咨询中心高级顾问；曾获联合国奖学金在美国加州伯克利大学人力资源研究所访问学习。我国人力资源管理咨询领域的创始学者之一。',
      cosKey: '',
      img: TcTm19
    },
    {
      name: '张春晓',
      desc: '北京大学经济学博士、区域经济学博士后，教授、北京大学经济与人类发展研究中心研究员，党的二十届四中全会宣讲团成员，国务院国资委专家组成员。',
      cosKey: '',
      img: TcTm12
    },
    {
      name: '刘志伟',
      desc: '中央党校（国家行政学院）教授、硕士生导师；中国领导科学学会常务理事、中国领导科学研究中心秘书长、中国政治学学会理事。曾任职于军委总部、国有银行总行和资产管理公司总部。',
      cosKey: '',
      img: TcTm07
    },
    {
      name: '欧阳红武',
      desc: '美国耶鲁大学博士，康乃尔大学MBA，美国福坦莫大学商学院最佳教授奖得主，北京大学管理实践特聘教授，第一财经频道《头脑风暴》和《波士堂》节目顾问和评论员。',
      cosKey: '',
      img: TcTm25
    },
    {
      name: '施炜',
      desc: '知名战略管理专家，管理学者，管理学博士，实践智慧管理研究院发起创始人，兼任中国人民大学中国资本市场研究院高级研究员。著有《企业成长导航》等多部作品。',
      cosKey: '',
      img: TcTm14
    },
    {
      name: '李翔宇',
      desc: '数智化转型战略与管理变革权威专家，中国人工智能百人汇创新研究院院长，天津大学博士生导师，工信部领军人才企业导师，华为金牌讲师。',
      cosKey: '',
      img: TcTm16
    },
    {
      name: '高雄勇',
      desc: '飞马爆品工坊创始人。原小米电视副总裁、小米参谋部高级参谋、聪明键提出者、小米、海信、盛大的实践者和亲历者、小米电视、智能门锁等爆品打造者。从0到300亿项目的实际操盘者。',
      cosKey: '',
      img: TcTm24
    },
    {
      name: '伏磊',
      desc: '30多年企业战略高管经验，长期致力于帮助企业进行战略规划及组织领导力提升。任天堂大中华区首任资深副总裁，完成企业从0到100的市场成功全周期运营。',
      cosKey: '',
      img: TcTm06
    },
    {
      name: '狮明亮',
      desc: '全域增长创始人、全域增长研究院院长、商业教育IP狮明亮全域增长主理人；小红书大快消行业及直播商业化负责人、伊利集团创新事业总监、麦乐多集团品牌事业部及营销中心总经理。',
      cosKey: '',
      img: TcTm17
    },
    {
      name: '夏凯',
      desc: '25年大客户销售实战与营销管理经验，擅长政企大客户销售业务；原用友集团高管、事业部总经理、用友营销学院创始院长。',
      cosKey: '',
      img: TcTm10
    },
    {
      name: '刘月松',
      desc: '实战派高级培训师，中国沙盘设计与教学专家，中国沙盘模拟实战教学研究院院长，多家高校总裁研修班沙盘课程导师，多家管理咨询公司沙盘培训项目顾问，多家企业战略与运营管理顾问。',
      cosKey: '',
      img: TcLys04
    },
    {
      name: '逄增钢',
      desc: '30年一线业务和咨询经验经历，曾任凯洛格咨询集团合伙人、咨询总监；美世战略人才合作专家；用友软件公司售前总监。',
      cosKey: '',
      img: TcTm21
    },
    {
      name: '赵越',
      desc: '商业模式创新专家、沙盘体验课研发专家。商业敏感度”“商业模式全息图”概念的提出者。\n' +
        '长期研究高技术行业商业模式的生命周期、模式选择、创新迭代、落地实施。',
      cosKey: '',
      img: TcTm20
    },
    {
      name: '张秀滨',
      desc: '人力资源管理及战略咨询28年经验，曾就职于IBM业务咨询、强生中国、施耐德电气、自如、远景动力、博世中国等，历任HR战略咨询顾问、HR总监、组织及人才发展副总裁、CHO等职。',
      cosKey: '',
      img: TcTm26
    },
    {
      name: '闫静',
      desc: '连续九年任职于惠普、安捷伦等全球500强企业。担任多年资深财务经理工作，跨国公司财务管理经验丰富。',
      cosKey: '',
      img: TcTm22
    },
    {
      name: '解永军',
      desc: '清华大学继续教育学院特聘讲师，对外经贸大学客座教授。原正略钧策合伙人、副总裁、战略营销咨询中心总经理、培训与人才发展中心总经理。',
      cosKey: 'https://lecturermap-1319224539.cos.ap-beijing.myqcloud.com/cdn/%E5%AE%98%E7%BD%91/%E8%A7%A3%E6%B0%B8%E5%86%9B.mp4',
      img: TcXyj03
    },
    {
      name: '李常仓',
      desc: '禾思咨询创始人、人才盘点引领者、领导风格、团队氛围多项测评工具研发人、“组织与人才盘点”课程开发者。为数百家中国企业提供人才盘点与发展服务。',
      cosKey: '',
      img: TcTm15
    },
    {
      name: '蒋丽华',
      desc: '领导力与人力资源管理专家，ACCP企业教练，领越领导力、EQ2情商优势、DDI领导力认证导师，光辉国际领导潜力认证导师、哈佛商学院领导力开发认证导师。',
      cosKey: '',
      img: TcTm18
    },
  ])
  const carouselRef = useRef(null)

  const goToSlide = (index: number) => {
    if (carouselRef.current) {
      setCurrent(index)
      carouselRef.current.goTo(index)
    }
  };
  const imgAnim: any = false
    ? {
      y: 30,
      opacity: 0,
      delay: 600,
      type: 'from',
      ease: 'easeOutQuad',
    }
    : {
      x: 30,
      opacity: 0,
      type: 'from',
      ease: 'easeOutQuad',
    };

  const handlePlay = (item) => {
    setObj(item)
    setIsModalOpen(true)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const onChange = (currentSlide: number) => {
    setCurrent(currentSlide)
  };

  const onPackChange = (obj) => {
    if(obj.mode === 'leave') {
      setCurrent(0)
    }
  }

  const groups = [];
  for (let i = 0; i < data.length; i += chunkSize) {
    groups.push(data.slice(i, i + chunkSize));
  }
  return (
    <div className='wrap-lecturer home-page'>
      <OverPack playScale={0.3} component={Row} className='wrap-lecturer-box'>
        <QueueAnim
          key="text"
          type="left"
          leaveReverse
          ease={['easeOutQuad', 'easeInQuad']}
        >
          <QueueAnim
            component="ul"
            key="ul"
            type="left"
            ease="easeOutQuad"
          >
            <div className='wrap-lecturer-box-left'>
              <div className='title'>
                500+来自名校专家、名企实战讲师
              </div>
              {/*<div className='to-lecturer'>*/}
              {/*  <span>前往讲师地图</span>*/}
              {/*  <img src={BigArrows} alt=""/>*/}
              {/*</div>*/}
            </div>
          </QueueAnim>
        </QueueAnim>
        <QueueAnim
          key="right"
          leaveReverse
          type="right"
          delay={[0, 100]}
        >
          <TweenOne
            key="img"
            animation={imgAnim}
            component={Col}
          >
            <div className='wrap-lecturer-box-right'>
              <div className='block'>
                <div className='block-title'>优质课程</div>
                <div className='block-num'>
                  <TweenOne
                    key='2'
                    animation={{
                      Children: {
                        value: 961,
                        floatLength: 0,
                        formatMoney: true,
                      },
                      duration: 1000,
                      delay: 300,
                      ease: 'easeInOutCirc',
                    }}
                    component="span"
                  >
                    0
                  </TweenOne>
                  +
                </div>
              </div>
              <div className='block'>
                <div className='block-title'>累计服务企业学员</div>
                <div className='block-num'>
                  <TweenOne
                    key='1'
                    animation={{
                      Children: {
                        value: 50000,
                        floatLength: 0,
                        formatMoney: true,
                      },
                      duration: 1000,
                      delay: 300,
                      ease: 'easeInOutCirc',
                    }}
                    component="span"
                  >
                    0
                  </TweenOne>
                  +
                </div>
              </div>
            </div>
          </TweenOne>
        </QueueAnim>
      </OverPack>
      <OverPack playScale={0.3} onChange={onPackChange}>
        <QueueAnim
          type="bottom"
          key="block"
          delay={[0, 100]}
          className='wrap-lecturer-detail'
        >
          <div key="carousel">
            <AntCarousel
              ref={carouselRef}
              dots={false}
              infinite={false}
              afterChange={onChange}
            >
              {
                groups.map((group, groupIndex) => (
                  <div key={`row-${groupIndex}`}>
                    <QueueAnim
                      type="bottom"
                      component={Row}
                      style={{width: '100%'}}
                    >
                      {
                        group.map((item, i) => (
                          <Col key={i.toString()} md={8}>
                            <div className='item-block'>
                              <div className='item-block-font'>
                                <div className='item-block-font-top'>
                                  <div className='name'>{item.name}</div>
                                  <div className='desc'>{item.desc}</div>
                                </div>
                                {item?.cosKey && <div className='l-img' onClick={() => handlePlay(item)}></div>}
                              </div>
                              <img className='item-block-person' src={item.img} />
                            </div>
                          </Col>
                        ))
                      }
                    </QueueAnim>
                  </div>
                ))
              }
            </AntCarousel>
            <div className='flex-center m-t30'>
              {groups.map((item, i) => (
                <div className={`case ${i === current ? 'case-active' : ''}`} onClick={() => goToSlide(i)}></div>
              ))}
            </div>
          </div>
        </QueueAnim>
      </OverPack>
      <ModelVideo isModalOpen={isModalOpen} handleCancel={handleCancel} data={obj} />
    </div>
  )
}

export default Lecturer